if (!customElements.get('scene-hero-slideshow')) {
  customElements.define('scene-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      window.clearInterval(this.timer);
      this.slides = [...this.querySelectorAll('.sd-hero-image')];
      if (this.slides.length < 2) return;

      this.currentSlide = this.slides[Math.floor(Math.random() * this.slides.length)];
      this.currentSlide.loading = 'eager';
      this.currentSlide.fetchPriority = 'high';
      this.slides.forEach(slide => {
        slide.classList.toggle('is-active', slide === this.currentSlide);
      });
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      const interval = Math.min(20, Math.max(3, Number(this.dataset.interval) || 5));
      this.timer = window.setInterval(() => this.showRandomSlide(), interval * 1000);
    }

    showRandomSlide() {
      if (document.hidden || this.motionPreference.matches) return;

      const candidates = this.slides.filter(slide =>
        slide !== this.currentSlide && slide.complete && slide.naturalWidth > 0
      );
      if (!candidates.length) return;

      const nextSlide = candidates[Math.floor(Math.random() * candidates.length)];
      this.currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');
      this.currentSlide = nextSlide;
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }
  });
}
